import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import Axios from "axios";

const routePrefix = "/beoordelingcriteriavoortgangsrapport/";

const voortgangsrapportbeoordelingcriteriaApi = {
	get(vrProjectId) {
		const serviceUrl = prependRoot(routePrefix + vrProjectId, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(voortgangsrapportBeoordelingscriteria) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return Axios.post(serviceUrl, voortgangsrapportBeoordelingscriteria, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default voortgangsrapportbeoordelingcriteriaApi;